import React, { Component } from "react";
import { connect } from "react-redux";
import PropTypes from "prop-types";
import styles from "./IndretFormulariFoto.module.css";
import {
  getIndretFotosOriginals,
  getIndretFotosEliminades,
  getIndretFotosCreades
} from "../../reducers";
import { fotosOriginalsMenysFotosEliminades } from "../../utils/formularis";
import {
  MIDA_MAX_FOTO_INDRET_BYTES,
  NUM_MAX_FOTOS_INDRET
} from "../../constantsFormularis";

import IndretIntroduccioSelectorImatge from "./IndretIntroduccioSelectorImatge";

import {
  indretIntroduccioFotosCrearFoto,
  indretIntroduccioFotosEliminarFoto,
  indretIntroduccioFotosDescartarFoto
} from "../../actions";

class IndretIntroduccioFoto extends Component {
  descartarFoto(indexFotoCreadaADescartar) {
    this.props.indretIntroduccioFotosDescartarFoto(indexFotoCreadaADescartar);
  }

  eliminarFoto(indexFotoAEliminar) {
    const { fotosOriginalsMenysFotosEliminades } = this.props;
    const fotoAEliminar =
      fotosOriginalsMenysFotosEliminades[indexFotoAEliminar];
    this.props.indretIntroduccioFotosEliminarFoto(fotoAEliminar);
  }

  crearFoto(fitxerACrear) {
    this.props.indretIntroduccioFotosCrearFoto(fitxerACrear);
  }

  render() {
    const {
      fotosCreades,
      fotosOriginalsMenysFotosEliminades,
      fotosOriginals
    } = this.props;

    if (fotosOriginals && fotosOriginals.includes("Error obtenint fotos")) {
      return <div>{fotosOriginals.toString()}</div>;
    }

    if (!fotosOriginals) {
      return null;
    }

    const numFotosAMostrar =
      fotosOriginalsMenysFotosEliminades.length + fotosCreades.length;

    const botoAfegirFoto = (
      <IndretIntroduccioSelectorImatge
        urlImatgeOriginal={null}
        midaMaximaFotosEnBytes={MIDA_MAX_FOTO_INDRET_BYTES}
        eliminarFoto={this.descartarFoto.bind(this, fotosCreades.length)}
        crearFoto={this.crearFoto.bind(this)}
      />
    );

    const selectorsImatgesOriginalsMenysEliminades = () => {
      return fotosOriginalsMenysFotosEliminades.map((foto, index) => {
        return (
          <IndretIntroduccioSelectorImatge
            key={index}
            urlImatgeOriginal={foto.url}
            midaMaximaFotosEnBytes={MIDA_MAX_FOTO_INDRET_BYTES}
            eliminarFoto={this.eliminarFoto.bind(this, index)}
            crearFoto={this.crearFoto.bind(this)}
          />
        );
      });
    };

    const selectorsImatgesCreades = () => {
      return fotosCreades.map((foto, index) => {
        return (
          <IndretIntroduccioSelectorImatge
            key={index}
            urlImatgeOriginal={foto.url}
            midaMaximaFotosEnBytes={MIDA_MAX_FOTO_INDRET_BYTES}
            eliminarFoto={this.descartarFoto.bind(this, index)}
            crearFoto={this.crearFoto.bind(this)}
          />
        );
      });
    };

    const mostrarFotosOriginalsMenysEliminades = selectorsImatgesOriginalsMenysEliminades();
    const mostrarFotosCreades = selectorsImatgesCreades();

    return (
      <div className={styles.indretIntroduccioFoto}>
        {mostrarFotosOriginalsMenysEliminades} {mostrarFotosCreades}
        {numFotosAMostrar < NUM_MAX_FOTOS_INDRET ? botoAfegirFoto : null}
      </div>
    );
  }
}

IndretIntroduccioFoto.propTypes = {
  fotosOriginals: PropTypes.array,
  fotosEliminades: PropTypes.array,
  fotosCreades: PropTypes.array,
  fotosOriginalsMenysFotosEliminades: PropTypes.array,
  indretIntroduccioFotosEliminarFoto: PropTypes.func,
  indretIntroduccioFotosCrearFoto: PropTypes.func,
  indretIntroduccioFotosDescartarFoto: PropTypes.func,
  MIDA_MAX_FOTO_INDRET_BYTES: PropTypes.number,
  NUM_MAX_FOTOS_INDRET: PropTypes.number
};

const mapStateToProps = state => {
  const fotosOriginals = getIndretFotosOriginals(state);
  const fotosEliminades = getIndretFotosEliminades(state);

  return {
    fotosOriginals: fotosOriginals,
    fotosEliminades: fotosEliminades,
    fotosCreades: getIndretFotosCreades(state),
    fotosOriginalsMenysFotosEliminades: fotosOriginalsMenysFotosEliminades(
      fotosOriginals,
      fotosEliminades
    )
  };
};

const mapDispatchToProps = {
  indretIntroduccioFotosCrearFoto,
  indretIntroduccioFotosEliminarFoto,
  indretIntroduccioFotosDescartarFoto
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(IndretIntroduccioFoto);
